module.exports = __webpack_public_path__ + "static/img/终端.b03af9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/终端.png
// module id = FWJT
// module chunks = 13